// extracted by mini-css-extract-plugin
export var arrow = "styles-module--arrow--6628f";
export var button = "styles-module--button--7202c";
export var buttonText = "styles-module--buttonText--934d8";
export var contentContainer = "styles-module--contentContainer--563cb";
export var contentText = "styles-module--contentText--ea2b5";
export var rotate = "styles-module--rotate--43ddb";
export var visible = "styles-module--visible--3f052";